<template lang="pug">
    v-container.pa-5(fluid='' tag='section')
        v-col(cols="12").d-flex.justify-center
          p.d-inline Comparte tu codigo y por cada persona que lo utilize cada mes recibirás descuentos hasta del 10% del plan de tu referido:
          ShareNetwork(
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :url="sharing.url"
          :title="sharing.title"
          :description="sharing.description"
          :quote="sharing.quote"
          :hashtags="sharing.hashtags"
          ).mx-2
            v-icon(size="30" color="primary") {{network.icon}}
        v-dialog(v-model='showLogsDialog' :fullscreen="isMobile" max-width='600')
          v-card
            v-card-title.headline Historial de pagos
            v-card-text
              p {{userSelected.name}} ha aportado $ {{userHistoricAmount}} en comisiones
            v-data-table.elevation-1(v-if="!isMobile" :headers="headersLogs" :items="selectedLog" :items-per-page="15")
            v-flex(v-else md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="selectedLog.length > 0")
                  v-list-item-group
                    template(v-for="(item, index) in selectedLog.slice(10*(pageLog-1), 10*(pageLog))")
                      v-list-item(:key="item.email").notification
                          template(v-slot:default="{ active, toggle }")
                              v-list-item-content()
                                  p.mt-2 {{'Plan: ' + item.plan}}
                                  p.mt-2.notification__date {{'Tipo: ' + item.type}}
                                  span.mt-2.notification__date {{'Costo: ' + item.cost}}
                                  p.mt-2.font-weight-bold.notification__price {{'Comision(10%): ' + item.commission}}
                                  p.mt-2.notification__date {{'Fecha: ' + item.paymentDay}}
                          v-divider(v-if="index + 1 < selectedLog.length" :key="index")
                    v-pagination.my-4(v-model="pageLog" :length="pageNumberLog")
              template(v-else)
                NoResults(title="No tienes referidos", description="Aqui se mostraran tus referidos")
            v-card-actions
              v-spacer
              v-btn(color="primary" @click="showLogsDialog = false") Cerrar
        v-dialog(v-model='showWithdrawDialog' :fullscreen="isMobile" max-width='600')
          v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
            | {{ snackbar.text }}
            v-btn(dark='' text='' @click='snackbar.snackbar = false')
              | {{$t('payment.general.close')}}
          v-card
            v-card-title.headline Retirar comisiones
            v-card-text
              v-form(ref='form' lazy-validation='')
                v-row
                  v-col(cols="12" md="12").text-center.pa-0.ma-0
                    label El retiro minimo es de $ 30.00 USD.
                  v-col(cols="12" md="12").text-center
                    label Tus comisiones son:
                    h3 ${{amount}} USD
                    label ¿Cuanto deseas retirar?
                  v-col(cols="12" md="6")
                    v-text-field(v-model="amountToWithdraw" type="number" min="20" :max="amount")
                  v-col(cols="12" md="6")
                    v-slider(v-model="amountToWithdraw" :max="amount" :min="0" thumb-label="always").mt-2
                    p(v-if="amountToWithdraw > amount").primary--text El monto no puede ser mayor a sus comisiones
                  // v-col(cols="12" md="6")
                    v-text-field(label="Monto a retirar" required :rules="amountRules" type="number" min="0" v-model="amountToWithdraw")
                  // v-col(cols="12" md="6" class="d-flex align-center")
                    h3 / minimo: 30 USD, máximo: {{amount}}
                  v-col(cols="12" md="12")
                    v-text-field(label="Email de paypal" required :rules="emailRules" type="text" v-model="emailPaypal")
            v-card-actions
              v-spacer
              v-btn(color="green" :disabled="amountToWithdraw == '0' || !emailPaypal" @click="sendWithdrawRequest") Enviar solicitud
              v-btn(color="error" @click="showWithdrawDialog = false") Cancelar
        // Cards Desktop
        v-row(v-if="!isMobile")
          v-col(cols="6")
            v-row(align='center' justify='center' style="height: 240px;")
              base-material-stats-card(color='success' icon='mdi-cash-multiple' title="Comisiones acumuladas" :value="amount" smallValue=" USD" :subText="getCurrencyValue(amount)+' '+getCurrencyName()" sub-icon='mdi-cash') <!--  sub-text='Monto acumulado por tus referidos'-->
          v-col(cols="6")
            v-row(align='center' justify='center' style="height: 240px;")
              v-btn(color="primary" v-if="profile.referal_code === undefined && !buttonClicked" @click="getReferralCode") Generar código
              v-tooltip(v-if="profile.referal_code === undefined && !buttonClicked" max-width="200" bottom="")
                template(v-slot:activator="{ on, attrs }")
                  v-icon.ml-2.mr-1(size="16" v-bind="attrs" v-on="on")
                    | mdi-information-outline
                span
                  | Este código lo podrás compartir con otras personas. Por cada persona que utilize este código cada mes recibirás descuentos hasta del 10% del plan de tu referido.
              v-progress-circular(v-if="loading" indeterminate="" color="primary")
              p(v-if="loading") Generando codigo
              ReferralsCard(v-if="profile.referal_code !== undefined" color='success' icon='mdi-share-variant' title="Código para compartir" :value="profile.referal_code")
        // Cards mobile
        v-row(v-else)
          v-col(cols="6")
            mobileCard(color='success', icon='mdi-cash-multiple', valueIcon='$' title="Comisiones acumuladas", :value="amount" smallValue=" USD" :subText="getCurrencyValue(amount)+' '+getCurrencyName()" sub-icon='mdi-cash')
          v-col(cols="6")
            v-btn(color="primary" v-if="profile.referal_code === undefined && !buttonClicked" @click="getReferralCode") Generar código
            v-tooltip(v-if="profile.referal_code === undefined && !buttonClicked" max-width="200" bottom="")
              template(v-slot:activator="{ on, attrs }")
                v-icon.ml-2.mr-1(size="16" v-bind="attrs" v-on="on")
                  | mdi-information-outline
              span
                | Este código lo podrás compartir con otras personas. Por cada persona que utilize este código cada mes recibirás descuentos hasta del 10% del plan de tu referido.
            v-progress-circular(v-if="loading" indeterminate="" color="primary")
            p(v-if="loading") Generando codigo
            mobileCard(v-if="profile.referal_code !== undefined" valueIcon='' color='success' icon='mdi-share-variant' title="Código para compartir" :value="profile.referal_code")
        v-row.mb-5
          h2 Lista de referidos
          v-btn(class="ml-3" color='primary' @click="withdrawCommissions" :disabled="amount === 0") retirar comisiones <!-- @click="probarpagos" -->
        v-row
          v-col(cols="12")
            v-progress-linear(v-if="loadingLinearBar" indeterminate="" color="primary")
            v-data-table.elevation-1(v-if="!isMobile" :headers="headers" :items="referrals" :items-per-page="10" item-key="email" show-expand :expanded.sync="expanded")
              template(v-slot:expanded-item="{ headers, item }")
                td(:colspan="headers.length")
                  v-row
                    v-data-table.elevation-1(style="width: 100%" v-if="!isMobile && item.childs.length > 0" :headers="headers" :items="item.childs" :items-per-page="10")
                    p(  style="display: block; margin: 0 auto;" v-else) No tiene referidos
              template(v-slot:item.actions="{ item }")
                v-btn(text icon='' color='primary' @click="openReferralLogs(item)")
                  v-icon mdi-eye
                v-tooltip(bottom="")
                  template(v-slot:activator="{ on, attrs }")
                    v-btn(text dark small color='primary' @click.stop='replyContact(item)' v-bind="attrs" v-on="on")
                      v-icon mdi-email
                  span Enviar correo
            v-flex(v-else-if="!loadingLinearBar" md12='' style="max-width: 700px").mx-auto.mt-3
              v-list(two-line="" v-if="referrals.length > 0")
                  v-list-item-group
                    template(v-for="(item, index) in referrals.slice(10*(page-1), 10*(page))")
                      v-list-item(:key="item.email").notification
                          template(v-slot:default="{ active, toggle }")
                              v-list-item-content()
                                  p.font-weight-bold {{'Nombre: ' + item.name}}
                                  p.mt-2 {{'Plan: ' + item.plan}}
                                  p.mt-2.notification__date {{'Tipo: ' + item.type}}
                                  span.mt-2.font-weight-bold.notification__price {{'Estado: ' + item.state}}
                                  p.mt-2.notification__date {{'Email: ' + item.email}}
                                  p.mt-2.notification__date {{'Telefóno: ' + item.phone}}
                                  v-row.align-center
                                    v-btn( icon='' color='primary' @click="openReferralLogs(item)")
                                      v-icon mdi-eye
                                    v-tooltip(bottom="")
                                      template(v-slot:activator="{ on, attrs }")
                                        v-btn(text dark small color='primary' @click.stop='replyContact(item)' v-bind="attrs" v-on="on")
                                          v-icon mdi-email
                                      span Enviar correo
                          v-divider(v-if="index + 1 < referrals.length" :key="index")
                    v-pagination.my-4(v-model="page" :length="pageNumber")
              template(v-else)
                NoResults(title="No tienes referidos", description="Aqui se mostraran tus referidos")
</template>

<script>
  import ReferralsCard from '@/components/custom/ReferralsCard'
  import * as vars from '@/vars.json'
  import { currencies } from '@/locales/countries.json'
  export default {
    components: {
      ReferralsCard: ReferralsCard,
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
      NoResults: () => import('@/components/custom/NoResults'),
    },
    data () {
      return {
        expanded: [],
        page: 1,
        pageLog: 1,
        msgTest: 'https://wa.me/?text=Usa+mi+c%C3%B3digo+http://localhost:8080/vuejs-pwa/#/referals/aaaaa',
        headers: [
          { text: 'Nombre', value: 'name' },
          { text: 'Plan', value: 'plan' },
          { text: 'Tipo', value: 'type' },
          { text: 'Estado', value: 'state' },
          { text: 'Email', value: 'email' },
          { text: 'Telefono', value: 'phone' },
          { text: 'Acciones', value: 'actions' },
        ],
        headersLogs: [
          { text: 'Fecha(dia/mes/año)', value: 'paymentDay' },
          { text: 'Plan', value: 'plan' },
          { text: 'Tipo', value: 'type' },
          { text: 'Costo', value: 'cost' },
          { text: 'Comision(10%)', value: 'commission' },
        ],
        amountRules: [
          v => !!v || 'Ingrese un monto',
        ],
        emailRules: [
          v => !!v || 'email requerido',
          v => /.+@.+\..+/.test(v) || 'email invalido',
        ],
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 10000,
        },
        loading: false,
        loadingLinearBar: false,
        buttonClicked: false,
        referrals: [],
        logs: [],
        selectedLog: [],
        userSelected: '',
        userHistoricAmount: 0,
        showWithdrawDialog: false,
        showLogsDialog: false,
        emailPaypal: '',
        amountToWithdraw: 0,
        amount: '0',
      }
    },
    computed: {
      currencies () {
        return this.$store.getters['payment/getCurrencies']
      },
      pageNumber () {
        return Math.ceil(this.referrals.length / 10)
      },
      pageNumberLog () {
        return Math.ceil(this.selectedLog.length / 10)
      },
      profile () {
        return this.$store.getters['users/getProfile']
      },
      networks () {
        return [
          { network: 'facebook', name: 'Facebook', icon: 'mdi-facebook', color: '#1877f2' },
          { network: 'whatsapp', name: 'Whatsapp', icon: 'mdi-whatsapp', color: '#25d366' },
        ]
      },
      sharing () {
        return {
          url: `${vars.domain2.redirection}pages/register/${this.profile.referal_code}`,
          title: 'Utiliza mi codigo de referido cuando te registres en tender!',
          description: '',
          quote: 'quote',
          hashtags: 'tendershop',
        }
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    watch: {
      expanded (newVal, oldVal) {
        // console.log(newVal)
      },
    },
    created () {
      const vm = this
      vm.loadingLinearBar = true
      const userId = vm.$store.state.users.user.uid
      vm.$store.dispatch('referrals/getReferralsListAndAmount', userId).then(res => {
        // console.log(res)
        vm.loadingLinearBar = false
        if (res.referrals) {
          vm.referrals = res.referrals
          vm.logs = res.logs
          vm.amount = res.amount ? res.amount.toString() : '0'
        } else {
          vm.referrals = res // viene []
          vm.logs = []
          vm.amount = '0'
        }
      })
      vm.$store.dispatch('payment/getCurrencies').then(() => vm.getCurrencyValue())
    },
    methods: {
      replyContact (item) {
        window.location.href = `mailto:${item.email}?subject=Contacto del equipo de Tender`
      },
      getReferralCode () {
        this.loading = true
        this.buttonClicked = true
        setTimeout(() => {
          this.$store.dispatch('referrals/codeGenerator').then(() => {
            // Codigo generado
            this.loading = false
          })
        }, 2000)
      },
      openReferralLogs (user) {
        this.pageLog = 1
        this.userSelected = user
        const index = this.referrals.indexOf(user)
        if (index > -1) {
          this.selectedLog = this.logs[index].reverse()
          this.userHistoricAmount = 0
          for (const logRow of this.selectedLog) {
            logRow.plan = logRow.plan.replace('_', ' ')
            logRow.type = logRow.type === 'year' ? 'anual' : 'mensual'
            this.userHistoricAmount = this.userHistoricAmount + (+logRow.commission)
          }
        }
        this.showLogsDialog = true
      },
      withdrawCommissions () {
        this.showWithdrawDialog = true
      },
      sendWithdrawRequest () {
        const val = this.$refs.form.validate()
        if (val) {
          if (this.amountToWithdraw >= 30 && this.amountToWithdraw <= +this.amount) {
            this.showWithdrawDialog = false
            this.amount -= this.amountToWithdraw
            // enviar solicitud a super admin
            const date = new Date()
            const requestData = {
              amount: this.amountToWithdraw,
              fullname: this.$store.state.users.profile.name + ' ' + this.$store.state.users.profile.last_name,
              accountNumber: this.emailPaypal,
              userId: this.$store.state.users.user.uid,
              requestDay: date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear(),
            }
            this.$store.dispatch('referrals/sendWithdrawRequest', requestData).then(res => {

            })

            this.setDataNotification(true, 'success', 'Solicitud enviada')
          } else {
            this.setDataNotification(true, 'error', 'La cantidad ingresada no es correcta')
          }
        } else {
          this.setDataNotification(true, 'error', 'Ingrese el correo')
        }
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      probarpagos () {
        this.$store.dispatch('referrals/probarpagos', () => {
          // cobrado
        })
      },
      getCurrencyValue (amount) {
        const vm = this
        let country = 'Colombia'
        if (vm.profile.direction) {
          country = vm.profile.direction.country
        }

        const currencyObj = currencies.find(item => item.country === country)
        const currencyCode = currencyObj ? currencyObj.currency : 'COP'
        const currencyPair = `USD${currencyCode}`

        if (vm.currencies[currencyPair]) {
          return this.numberFormat(Math.ceil(parseFloat(vm.currencies[currencyPair]) * amount))
        } else {
          return this.numberFormat(amount) // Valor por defecto si no se encuentra el par de divisas
        }
      },
      numberFormat (val) {
        if (val) {
          const fixed = Number.parseFloat(val).toFixed(0)
          return fixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        } else return '0'
      },
      getCurrencyName () {
        const vm = this
        let country = 'Colombia'
        if (vm.profile.direction) {
          country = vm.profile.direction.country
        }
        const currencyObj = currencies.find(item => item.country === country)
        const currencyCode = currencyObj ? currencyObj.currency : 'COP'
        return currencyCode
      },
    },
  }
</script>

<style lang='scss' scoped>
.notification{
  display: flex;
  width: 95%;
  margin: 0 auto;
  // border-radius: 10px !important;
  box-shadow: -7px 4px 38px rgba(0, 0, 0, 0.16);
  &__container{
    @media (max-width: 1024px){
      background: transparent;
    }
  }
  &__date{
    font-size: 13px;
    color: #808184;
  }
  &__price{
    color: #35a3a9 !important;
  }
  &__description{
    color: #808184;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.2;
  }
}
</style>
